import { render, staticRenderFns } from "./list.vue?vue&type=template&id=133c36e6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=133c36e6&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=133c36e6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c36e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133c36e6')) {
      api.createRecord('133c36e6', component.options)
    } else {
      api.reload('133c36e6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=133c36e6&scoped=true", function () {
      api.rerender('133c36e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/market/activity/apply/list.vue"
export default component.exports